import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setEditId, selectUserById } from "../../../store/sticker_maker/usersSlice";
import { destroyUser, fetchUser } from "../../../actions/sticker_maker/usersActions";
import { formattedDate } from "../../../helpers/DateHelpers";
import stickerMakerUrls from "../../../configs/sticker_maker/stickerMakerUrls";

import { message } from "antd";
import PageLayout from "../_partials/PageLayout";
import SummaryShow from "../../../componets/SummaryShow";
import StickerPacks from "./_partials/_StickerPacks";
import Tabs from "../../../componets/Tabs";
import Edit from "./Edit";
import { ButtonDestroy, ButtonEdit } from "../../../componets/Buttons";
import SidebarShow from "../Users/_partials/_SidebarShow";

const Show: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAppSelector(state => id ? selectUserById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchUser(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    if (user) {
      dispatch(setEditId(user.id));
    }
  }

  function onClickDestroy() {
    if (user) {
      handleDestroy(user.id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyUser(id));

    if (destroyUser.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(stickerMakerUrls.contentPath()), 1000);
    }

    if (destroyUser.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <PageLayout className='v-users-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            user &&
              <SummaryShow
                title={user.username}
                subtitle={`Last seen: ${formattedDate(user.launch_at).fromNow}`}
                image={user.avatar_url}
                createdAt={user.created_at}
                updatedAt={user.updated_at}
                actions={[
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                  <ButtonDestroy key='button-destroy' onClick={onClickDestroy} />
                ]}
                className='v-mb-15'
              />
          }

          <Tabs
            paramsKey='tab'
            destroyInactiveTabPane={true}
            items={[
              { label: 'Sticker Packs', key: 'sticker_packs', children: <StickerPacks userId={user?.id} /> },
            ]}
          />
        </div>
      </div>

      <Edit />

      <SidebarShow user={user} />
    </PageLayout>
  )
}

export default Show;
